import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero, DraftNotice } from "@/components/common/SectionHeading";
import { api } from "@/lib/lnlApi";

export default function Department() {
    const { slug } = useParams();
    const [data, setData] = useState(null);
    useEffect(() => { api.get(`/departments/${slug}`).then((r) => setData(r.data)).catch(() => setData(null)); }, [slug]);
    if (!data) return <div className="lnl-container py-16 text-lnl-gray">Loading department…</div>;
    const { department, programs } = data;
    return (
        <div data-testid={`department-${slug}`}>
            <PageHero
                eyebrow={department.level === "college" ? "College" : "Basic education"}
                title={department.name}
                description={department.short}
                breadcrumbs={[{ label: "Home", to: "/" }, { label: "Academics", to: "/academics" }, { label: department.name }]}
            />
            <section className="py-12 bg-white">
                <div className="lnl-container">
                    {department.confirm && <div className="mb-6"><DraftNotice tone="warn">{department.confirm}</DraftNotice></div>}
                    {(department.themes || []).length > 0 && (
                        <div className="mb-8">
                            <div className="lnl-eyebrow">Program themes</div>
                            <div className="mt-3 flex flex-wrap gap-2">
                                {department.themes.map((t) => <span key={t} className="text-xs bg-lnl-off-white border border-lnl-border rounded-full px-3 py-1 text-lnl-charcoal">{t}</span>)}
                            </div>
                        </div>
                    )}
                    <h2 className="font-heading text-2xl font-bold text-lnl-charcoal">Programs</h2>
                    <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                        {programs.map((p) => (
                            <Link key={p.slug} to={`/programs/${p.slug}`} className="lnl-card p-5 hover:border-lnl-green/40" data-testid={`dept-program-${p.slug}`}>
                                <div className="lnl-eyebrow">{p.level.toUpperCase()}</div>
                                <div className="font-heading font-bold text-lg text-lnl-charcoal mt-1">{p.name}</div>
                                <div className="text-sm text-lnl-gray mt-2">{p.overview}</div>
                                <div className="mt-3 text-xs text-lnl-green-deep font-heading font-semibold inline-flex items-center gap-1">View program <ArrowRight className="h-3.5 w-3.5" /></div>
                            </Link>
                        ))}
                        {programs.length === 0 && <div className="text-sm text-lnl-gray">Programs for this department will be added by administrators.</div>}
                    </div>
                </div>
            </section>
        </div>
    );
}
